import React from "react";
import { Check, X } from "lucide-react";

const passwordRules = [
  {
    rule: (value: string) => value.length >= 12,
    message: "12 characters minimum",
  },
  {
    rule: (value: string) => /[0-9]/.test(value),
    message: "Number",
  },
  {
    rule: (value: string) => /[A-Z]/.test(value),
    message: "Uppercase character",
  },
  {
    rule: (value: string) => /[a-z]/.test(value),
    message: "Lowercase character",
  },
  {
    rule: (value: string) => /[^A-Za-z0-9]/.test(value),
    message: "Special character",
  },
];

interface PasswordValidationInputProps {
  value: string;
  show: boolean;
}

const PasswordValidationInput: React.FC<PasswordValidationInputProps> = ({ value, show }) => {
  const validationStatus = passwordRules.map(({ rule }) => rule(value));
  if (!show) return null;
  return (
    <div className="w-full mt-2 grid grid-cols-2 gap-x-4 gap-y-1">
      {passwordRules.map(({ message }, idx) => (
        <div
          key={idx}
          className="flex items-center gap-1 text-sm"
        >
          {validationStatus[idx]
            ? <Check size={16} className="text-[#4BB69C]" />
            : <X size={16} className="text-red-500" />
          }
          <span className={validationStatus[idx] ? "text-black" : "text-red-500"}>
            {message}
          </span>
        </div>
      ))}
    </div>
  );
};

export default PasswordValidationInput; 